"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Points extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getClassName", (id, serieId) => {
      const _this$props = this.props,
            currentPoint = _this$props.currentPoint,
            currentSlice = _this$props.currentSlice;
      let classNames = [];
      const pointClass = "point--" + id.toString().replace('.', '-');
      const serieClass = "serie--" + serieId.toString().replace('.', '-');
      classNames.push('point');
      classNames.push(pointClass);
      classNames.push(serieClass);
      let isCurrent;

      if (currentPoint && currentPoint.id && currentPoint.id === id) {
        isCurrent = true;
      }

      if (currentSlice && currentSlice.points) {
        const inCurrentSlice = currentSlice.points.filter(point => {
          if (point.id === id) {
            return true;
          }
        });

        if (inCurrentSlice.length) {
          isCurrent = true;
        }
      }

      if (isCurrent) {
        classNames.push('point--is-current');
      }

      return classNames.join(' ');
    });

    _defineProperty(this, "renderPoint", (point, index) => {
      const id = point.id,
            serieId = point.serieId,
            serieColor = point.serieColor,
            x = point.x,
            y = point.y;
      const className = this.getClassName(id, serieId);
      const transform = "translate(" + x + ", " + y + ")";
      return _react.default.createElement("circle", {
        transform: transform,
        className: className,
        r: "2",
        fill: "transparent",
        stroke: serieColor,
        strokeWidth: "4"
      });
    });
  }

  render() {
    const points = this.props.points;
    return _react.default.createElement("g", {
      className: "points"
    }, points.map(this.renderPoint));
  }

}

var _default = Points;
exports.default = _default;
module.exports = exports.default;